// extracted by mini-css-extract-plugin
export default {"inputField":"CreateAcademyProjectModal_inputField__vv9MN"};